<template>
  <div class="recipe_add">
         <br/>

    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>处方导出</el-breadcrumb-item>
    </el-breadcrumb>

    <hr />

    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="处方导出" name="first">
            <el-container>
            <!-- <el-header> 空置区域  </el-header> -->
            <el-main>
                <el-form ref="form" :model="form" label-width="200px">
                <table width="100%">
                    <tr>
                        <td>
                            <el-form-item label="下单日期">
                                <el-date-picker
                                    v-model="formModels.orderData"
                                    align="right"
                                    type="date"
                                    placeholder="选择日期"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">查询</el-button>
                            </el-form-item>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            
                        </td>
                        <td>
                            <el-form-item>
                                <el-button @click="exportSelectedOrder">导出选择处方</el-button>

                                <el-button @click="exportAllOrder">导出全部处方</el-button>
                            </el-form-item>
                        </td>
                    </tr>
                    </table>
                    </el-form>

                <div class="form-region-header font-30"><!-- 表格上方标题文字占位 --></div> 
                <table width="100%">
                    <tr>
                        <td>
                            <el-table :data="tableData" style="width: 100%">
                                <el-table-column prop="date" label="序号" width="180">
                                </el-table-column>
                                <el-table-column prop="username" label="选择" width="180">
                                </el-table-column>
                                <el-table-column prop="status" label="创建时间">
                                </el-table-column>
                                <el-table-column prop="operation" label="患者">
                                </el-table-column>
                                <el-table-column prop="operation" label="性别">
                                </el-table-column>
                                <el-table-column prop="operation" label="年龄">
                                </el-table-column>
                                <el-table-column prop="operation" label="症状">
                                </el-table-column>
                            </el-table>
                        </td>
                    </tr>
                    </table>
                     <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="100"
                        layout="total, prev, pager, next"
                        :total="1000">
                    </el-pagination>
            </el-main>
            </el-container>
        </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
export default {
  name: 'BatchPrint',
  data() {
      return {
        activeName: 'first',

        currentPage: '0',
        formModels: {
            orderDate: '',
        },
        formBinds: {
        },
        auditApi: 'http://www,google.com',
        rules: {
          name: [
            { required: true, message: '请输入患者姓名', trigger: 'blur' },
            { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
          ],
          medicine: [
            { required: true, message: '请选择药品名字', trigger: 'change' }
          ],
        },

        // 时间选取控件相关数据
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
      }
    },
  props: {
    msg: String,
  },
  methods: {
    exportAllOrder(formName) {
      console.log(formName)
      this.$confirm('是否同意?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.axios
            .get(this.DoctorApprovalApi)
            .then(response => (this.info = response.data))
            .catch(function(err) {
                alert(err);
            });
        }).catch(() => {
          //this.$message({
          //  type: 'info',  // success
          //  message: '已取消删除'
          // });          
        });
    },

    exportSelectedOrder(formName) {
      console.log(formName)
      this.$confirm('是否同意?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.axios
            .get(this.DoctorApprovalApi)
            .then(response => (this.info = response.data))
            .catch(function(err) {
                alert(err);
            });
        }).catch(() => {
          //this.$message({
          //  type: 'info',  // success
          //  message: '已取消删除'
          // });          
        });
    },
    // 分页相关
    handleSizeChange(val) {
    console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
    }
  },
  mounted () {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      this.$router.replace("/Login");
    }
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
